module.exports = "<i title=\"{{label}}\" class=\"icon {{value}}\"></i>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/icon-symbol/icon-symbol.component.html
// module id = ../../../../../src/app/modules/ui-base/components/icon-symbol/icon-symbol.component.html
// module chunks = main